// extracted by mini-css-extract-plugin
export default {"contentTitle":"reviewStep_contentTitle__E2b2E","jurisdiction":"reviewStep_jurisdiction__sjT5-"};